import { checkStatus } from '../../utilities/fetch';
import { createQueryString } from '../../utilities/utilities';
import { permissionsPath } from '../../utilities/api_relative_paths';

/**
 * Returns true if current_user has given permission. For permissions with credits,
 * it returns true if current_user has credits.
 *
 * Supported permissions are available in grape-api racksh by running command:
 * Permissions::Privilege.all
 *
 * @param {string} permission - permission name in MACRO_CASE, e.g. SEND_MESSAGES
 * @returns {Promise} promise - on success resolves to true or false
 */
const hasPermission = (permission) => {
  const queryParams = { charge_credits: false };

  return fetch(`${permissionsPath}/${permission}${createQueryString(queryParams)}`)
    .then(checkStatus)
    .then(response => response.json())
    .then(parsed => parsed.allowed)
    .catch((error) => Promise.reject(error));
};

/**
 * Performs POST request to assign package to users in bulk
 *
 *
 * @param {string} packageShortName - package to assign in short, e.g. 'PRO'
 * @param {Array} userIds - user ids, e.g. [1411751,671]
 * @returns {Promise} promise - resolves to response object containing successful and failed ids
 */
const assignPackagesToUsersInBulk = (packageShortName, userIds) => {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({
      consultant_ids: userIds,
      package_shortname: packageShortName,
    }),
    headers: {
      'Content-Type': 'application/json'
    },
  };

  const path = `${permissionsPath}/apply_packages`;

  return fetch(path, requestOptions)
    .then(checkStatus)
    .then(response => response.json());
};

export {
  hasPermission,
  assignPackagesToUsersInBulk
};
